/* Статус транзакции менеджер - курьер, менеджер - управляющий */

export default class TransactionStatus {
  static get New () { return 'new' } // создана, новая
  static get Wait () { return 'wait' } // заполнена менеджером и ожидает подтверждения курьером. На этом этапе транзакция показывается курьеру
  static get Completed () { return 'completed' } // завершена менеджером. Баланс изменился
  static get Cancel () { return 'cancel' } // транзакция отменена
}
